import React from 'react';
import Option from './Option';
import { Container, Title } from './RadioButtonSelector.styles';
import { FilterOption, SortMethodsTypes } from '../../types';

interface RadioButtonSelectorProps {
  name: string;
  value: string;
  onChange: (isNonAudiFilter: boolean | undefined, option: string) => void;
  title?: string;
  isVehiclesLoading?: boolean;
  options:
    | {
        [key: string]: FilterOption;
      }
    | SortMethodsTypes;
}

const RadioButtonSelector: React.FC<RadioButtonSelectorProps> = ({
  value,
  onChange,
  name,
  title,
  options,
  isVehiclesLoading,
}) => {
  return (
    <div role="group" aria-labelledby={`radio-button-group-${name}`}>
      {title && <Title id={`radio-button-group-${name}`}>{title}</Title>}
      <Container role="radiogroup">
        {Object.keys(options).map((item) => {
          const option = options[item];
          return (
            <Option
              key={`${option.value}`}
              {...option}
              name={name}
              onChange={onChange}
              checked={option.value === value}
              isVehiclesLoading={isVehiclesLoading}
            />
          );
        })}
      </Container>
    </div>
  );
};

export default RadioButtonSelector;
